module.exports = __webpack_public_path__ + "img/Stan-Lozovsky.60e72f8a.jpg";